import React from 'react';
import {Stages} from '../../actions/actions';
import '../../assets/styles/components.css';

export default class LogoutButton extends React.Component {
render(){
    let destStage = Stages.thankYou;
    if(this.props.stage === Stages.cards)
        destStage = Stages.welcome;

    if (this.props.stage === Stages.cards) {
        return (
            // <div className="logout-wrapper cards" onClick={() => this.props.onLogout(null,destStage)} aria-label="יציאה">
            //     <div className="logout-label">יציאה</div>
            //     <img className="logout-img" src={"themes/" + window.provider + "/images/Logout-icon.png" } alt="יציאה"/>
            // </div>
            null
        )    
    } else if (this.props.stage === Stages.pin) {
        return (
            // <div className="logout-wrapper pin color-n" onClick={() => this.props.onLogout(null,destStage)} aria-label="התנתק">
            //     <div className="logout-label">יציאה</div>
            //     <img className="logout-img" src={"themes/" + window.provider + "/images/Logout_W-icon.png" } alt="יציאה"/>
            // </div>
            null
        )
    } else {
        return (
            null
        )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/app/LogoutButton.jsx